export default __webpack_public_path__ + "static/media/DM_Glyph_FullColor.27b8479e.png";